<span class="address-availability__icon"></span>
<ul class="address-availability__text">
  <% if (hours.length) { %>
    <% _.each(hours, function(hour) { %>
      <li class="hour"><%= hour.day %>: <%= hour.times %></li>
    <% }) %>
  <% } else { %>
    <li class="hour"><%= alwaysOpenText %></li>
  <% } %>
</ul>
